goog.require('el8.ext.onboarding.displayMgr');
goog.require('el8.service.urls');

var el8 = el8 || {};
if(!el8.main) el8.main = {};
if(!el8.main.ext) el8.main.ext = {};
el8.main.ext.onboarding = {};

if (typeof(_gaq) === "undefined") { _gaq = []; }
el8Globals['OB'] = '/'+'onboarding'+'/'+'1.0'+'/'; // 2012-06

el8.main.ext.onboarding.init = function(spec) {
    el8.service.urls.init(spec.urls);
    el8.ext.onboarding.displayMgr.init();
};
